import * as jsxRuntime from "/home/runner/work/broadcast-bridge-web-app/broadcast-bridge-web-app/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment